module.exports = __webpack_public_path__ + "static/media/bg_downgrade_suggestion_over_50.d94c2e19.webp";